import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { i18n } from '@/i18n';
import InfoModal from '@/corePagesModule/components/InfoModal.vue';

// props

export default /*@__PURE__*/_defineComponent({
  __name: 'BulkEditConfirmModal',
  props: {
    modalState: { type: Boolean, default: false }
  },
  emits: ["save", "cancel", "discardAndClose"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

// emits
const emits = __emit;

const t = i18n.t;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(InfoModal, {
    "modal-state": _ctx.modalState,
    icon: "info",
    "back-button-label": _unref(t)('キャンセル'),
    "next-button-label": _unref(t)('保存'),
    "modal-width": 500,
    onOnBack: _cache[1] || (_cache[1] = ($event: any) => (emits('cancel'))),
    onOnNext: _cache[2] || (_cache[2] = ($event: any) => (emits('save')))
  }, {
    title: _withCtx(() => [
      _createTextVNode(_toDisplayString(_unref(t)('編集を完了')), 1)
    ]),
    description: _withCtx(() => [
      _createTextVNode(_toDisplayString(_unref(t)('受領用内示の編集を確定し、変更を保存します。')), 1)
    ]),
    footer: _withCtx(() => [
      _createElementVNode("button", {
        class: "discard-link",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (emits('discardAndClose')))
      }, _toDisplayString(_unref(t)('保存せずに終了')), 1)
    ]),
    _: 1
  }, 8, ["modal-state", "back-button-label", "next-button-label"]))
}
}

})